enum Recording {
  Finished,
  Identifier,
  Pending,
}

export default Recording;
